import React from 'react'
import "./HeroImgStyles.css"
import IntroImg from "../resources/IntoBG.jpg"
// import { Link } from 'react-router-dom'
import { Link, animateScroll as scroll } from "react-scroll";
import "./HeroImg.css"

const HeroImg = () => {
  return (
    <div className='hero' id="home">
        <div className='mask'>
<img className='into-img' src={IntroImg} alt="BannerImg"/>
        </div>
        <div className='content'>
            <p>HI I'M SHASHIKANT YADAV</p>
            <h1>Full Stack Web Developer</h1>
            <div>
            <Link 
            activeClass={"active"}
            spy={true}
            to="projects"
            smooth={true}
            offset={-100}
            delay={0}
            duration={0}
            className='btn'>PROJECTS</Link>
            {/* <Link to="/contact" className='btn-light'>Contact</Link> */}
            <button className="btn-light" ><a 
            href="https://drive.google.com/file/d/1IK_RuO422W3LBKClLBlmaQZ68OWD7Ooo/view"
            target="_blank"  // Open link in a new tab
            rel="noopener noreferrer" // Recommended for security reasons
            
            >Resume</a></button>
            </div>
        </div>
    </div>
  )
}

export default HeroImg